var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFunnel(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 105,
    height: 66,
    viewBox: "0 0 105 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M43.8887 66L33 49H71L61.5 66H43.8887Z",
    fill: "#8CD6A0"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5926 48L24 34H82L71.6889 48H32.5926Z",
    fill: "#7335CB"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M105 0H0L22.8074 33H82.6229L105 0Z",
    fill: "#3F64FA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFunnel);
export default __webpack_public_path__ + "static/media/funnel.346b831041b2a6d7dc03dd65b1f4349f.svg";
export { ForwardRef as ReactComponent };